import { render, staticRenderFns } from "./MealSku.vue?vue&type=template&id=616e39eb&"
import script from "./MealSku.vue?vue&type=script&lang=js&"
export * from "./MealSku.vue?vue&type=script&lang=js&"
import style0 from "./MealSku.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports